<template>
  <div class="p-5 bg-white border border-gray-200 rounded-2xl shadow-sm mb-4 hover:border-gray-300">
    <div
      class="cursor-pointer"
      @click="toggle"
    >
      <div class="flex justify-between items-center w-full font-medium text-left text-gray-900">
        <div class="flex">
          <svg
            v-if="isOpen"
            class="w-3 h-6 rotate-180 shrink-0"
            fill="none"
            height="2"
            viewBox="0 0 12 2"
            width="12"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.75 1H11.25"
              stroke="#374151"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
          </svg>
          <svg
            v-else
            class="w-3 h-6 shrink-0"
            fill="none"
            height="12"
            viewBox="0 0 12 12"
            width="12"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6 0.75V11.25M0.75 6H11.25"
              stroke="#374151"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
            />
          </svg>
          <h2 class="ml-2">
            <slot name="title" />
          </h2>
        </div>
        <span class="text-sm text-gray-500">
          <slot name="content-count" />
        </span>
      </div>
      <div class="mt-3">
        <div class="mb-2 flex justify-between items-center">
          <h3 class="text-sm font-medium text-gray-600">
            <slot name="progress-label" />
          </h3>
          <span class="text-sm text-gray-700">
            <slot name="progress-percent" />
          </span>
        </div>
        <div
          :aria-valuenow="progress"
          aria-valuemax="100"
          aria-valuemin="0"
          class="flex w-full h-1 bg-gray-200 rounded-full overflow-hidden"
          role="progressbar"
        >
          <div
            :style="{ width: progress + '%' }"
            class="flex flex-col justify-center overflow-hidden bg-primary text-xs text-white text-center whitespace-nowrap transition duration-500"
          />
        </div>
      </div>
    </div>
    <div
      v-show="isOpen"
      class="mt-3"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "Accordion",
  props: {
    progress: {
      type: Number,
      default: 0,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:isOpen'],
  setup(props, {emit}) {
    const toggle = () => {
      emit('update:isOpen', !props.isOpen);
    };

    return {toggle};
  },
});
</script>
